const KEY = "voorent-recent-searches";
const LIMIT = 6;

export function getRecentSearches() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list.filter((item) => typeof item === "string").slice(0, LIMIT) : [];
  } catch (e) {
    return [];
  }
}

export function addRecentSearch(query) {
  const q = String(query || "").trim();
  if (!q) return;
  const next = [q, ...getRecentSearches().filter((item) => item.toLowerCase() !== q.toLowerCase())].slice(0, LIMIT);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    // Ignore storage failures (private mode / quota).
  }
}

export function clearRecentSearches() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    // Ignore storage failures.
  }
}
